import { StoreService } from "@/services/features/StoreService";
import { User } from "@/types/auth";
import { UserRole } from "@/utils/roleManager";

export interface UserTypeState {
  isCraveUser: boolean;
  defaultCustomerId?: number;
  allowedStores?: number[];
  canSelectCustomer: boolean;
  canSelectStore: boolean;
  requiresCustomerSelection: boolean;
  requiresStoreSelection: boolean;
}

export class UserTypeService {
  private static instance: UserTypeService;
  private storeService: StoreService;

  private constructor() {
    this.storeService = StoreService.getInstance();
  }

  public static getInstance(): UserTypeService {
    if (!UserTypeService.instance) {
      UserTypeService.instance = new UserTypeService();
    }
    return UserTypeService.instance;
  }

  public isCraveUser(role: string): boolean {
    return [UserRole.CRAVE_ADMIN, UserRole.CRAVE_PRIVILEGE, UserRole.CRAVE_EMPLOYEE].includes(
      role as UserRole,
    );
  }

  public getUserTypeState(user: User | null): UserTypeState {
    if (!user) {
      return {
        isCraveUser: false,
        canSelectCustomer: false,
        canSelectStore: false,
        requiresCustomerSelection: false,
        requiresStoreSelection: false,
      };
    }

    const isCraveUser = this.isCraveUser(user.role);

    return {
      isCraveUser,
      defaultCustomerId: isCraveUser ? undefined : user.customerId,
      allowedStores: isCraveUser ? undefined : user.allowedStores,
      canSelectCustomer: isCraveUser,
      canSelectStore: isCraveUser || Boolean(user.customerId),
      requiresCustomerSelection: isCraveUser,
      requiresStoreSelection: true,
    };
  }
}
